export default {"src":"/_next/static/media/esp_flag.ed9d2d81.svg","height":13,"width":18,"blurWidth":0,"blurHeight":0};